module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Regular.woff";